<template>
  <div class="text-black my-3 fs-14" id="TemplateViewPhieugGMTM">
    <div
      class="sticky top-0 flex justify-content-end bg-white text-base font-semibold z-50 mb-3"
    >
      <a
        v-if="form.pdf_url"
        target="_blank"
        :href="form.pdf_url"
        class="btn bg-pri bd-pri text-white"
        >Xem file gốc</a
      >
      <button
        class="btn border-none text-black px-3 mx-2 fs-14 fw-500"
        @click="openModalSignPdf($route.query.vId)"
        :disabled="loading"
      >
        <div class="loading" v-if="loading">
          <div class="spinner-border mr-2" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          viewBox="0 0 16 16"
        >
          <path
            fill="#03267A"
            d="M9.021 1.772a2.445 2.445 0 0 1 3.458 3.457l-.272.271l.086.086a2 2 0 0 1 0 2.828l-1.44 1.44a.5.5 0 0 1-.707-.707l1.44-1.44a1 1 0 0 0 0-1.414l-.086-.086l-5.646 5.647a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.595-.643l1.25-3.75a.5.5 0 0 1 .12-.195l6.625-6.625Zm2.75.707a1.445 1.445 0 0 0-2.042 0L3.187 9.02l-.925 2.774l2.982-.745l6.527-6.527a1.445 1.445 0 0 0 0-2.043ZM4.967 15c-1.235 0-2.208-.566-2.855-1.107l1.284-.32a3.2 3.2 0 0 0 1.57.427c.406 0 .824-.164 1.27-.457c.447-.293.878-.687 1.314-1.095l.113-.107c.385-.361.784-.737 1.166-.996c.408-.278.95-.53 1.517-.311c.376.144.62.41.791.736c.161.306.272.688.38 1.105c.05.19.133.374.23.498a.46.46 0 0 0 .114.112c.025.015.036.015.039.015c.122 0 .331-.082.63-.286c.185-.126.344-.252.502-.379c.098-.078.197-.157.302-.235c.279-.209.52-.349.697-.438a3.05 3.05 0 0 1 .278-.124l.02-.008l.007-.002l.003-.001h.001l.16.473l-.159-.474a.5.5 0 0 1 .321.947l-.004.002a2.141 2.141 0 0 0-.175.08c-.13.064-.321.174-.55.346c-.059.043-.135.104-.223.174c-.181.143-.409.324-.618.466c-.31.212-.741.46-1.192.46c-.436 0-.751-.265-.946-.517a2.435 2.435 0 0 1-.405-.858c-.11-.423-.196-.7-.296-.89c-.09-.168-.17-.232-.266-.27c-.082-.03-.245-.033-.595.206c-.313.212-.655.533-1.058.912l-.1.093c-.431.405-.92.855-1.449 1.202c-.53.348-1.14.621-1.818.621Z"
          />
        </svg>
        {{ $t("Ký") }}
      </button>
      <button
        class="btn border-none text-black px-3 mx-2 fs-14 fw-500"
        @click="onPrintNe"
        :disabled="loading"
      >
        <div class="loading" v-if="loading">
          <div class="spinner-border mr-2" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 14H17C17.2652 14 17.5196 13.8946 17.7071 13.7071C17.8946 13.5196 18 13.2652 18 13V7C18 6.73478 17.8946 6.48043 17.7071 6.29289C17.5196 6.10536 17.2652 6 17 6H3C2.73478 6 2.48043 6.10536 2.29289 6.29289C2.10536 6.48043 2 6.73478 2 7V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H4V9H16V14ZM4 4V0H16V4H17C17.7956 4 18.5587 4.31607 19.1213 4.87868C19.6839 5.44129 20 6.20435 20 7V13C20 13.7956 19.6839 14.5587 19.1213 15.1213C18.5587 15.6839 17.7956 16 17 16H16V20H4V16H3C2.20435 16 1.44129 15.6839 0.87868 15.1213C0.31607 14.5587 0 13.7956 0 13L0 7C0 6.20435 0.31607 5.44129 0.87868 4.87868C1.44129 4.31607 2.20435 4 3 4H4ZM6 18H14V11H6V18ZM6 4H14V2H6V4Z"
            fill="#03267A"
          />
        </svg>
        {{ $t("multidisciplinary_board.lbl_print") }}
      </button>
      <button
        class="btn border-none text-black px-3 mx-2 fs-14 fw-500"
        @click="ModalUpdate(true)"
        :disabled="loading"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.75 8.99995C15.5511 8.99995 15.3603 9.07897 15.2197 9.21962C15.079 9.36028 15 9.55104 15 9.74995V14.25C15 14.4489 14.921 14.6396 14.7803 14.7803C14.6397 14.9209 14.4489 15 14.25 15H3.75C3.55109 15 3.36032 14.9209 3.21967 14.7803C3.07902 14.6396 3 14.4489 3 14.25V3.74995C3 3.55104 3.07902 3.36028 3.21967 3.21962C3.36032 3.07897 3.55109 2.99995 3.75 2.99995H8.25C8.44891 2.99995 8.63968 2.92094 8.78033 2.78028C8.92098 2.63963 9 2.44887 9 2.24995C9 2.05104 8.92098 1.86028 8.78033 1.71962C8.63968 1.57897 8.44891 1.49995 8.25 1.49995H3.75C3.15326 1.49995 2.58097 1.73701 2.15901 2.15896C1.73705 2.58092 1.5 3.15322 1.5 3.74995V14.25C1.5 14.8467 1.73705 15.419 2.15901 15.8409C2.58097 16.2629 3.15326 16.5 3.75 16.5H14.25C14.8467 16.5 15.419 16.2629 15.841 15.8409C16.2629 15.419 16.5 14.8467 16.5 14.25V9.74995C16.5 9.55104 16.421 9.36028 16.2803 9.21962C16.1397 9.07897 15.9489 8.99995 15.75 8.99995ZM4.5 9.56995V12.75C4.5 12.9489 4.57902 13.1396 4.71967 13.2803C4.86032 13.4209 5.05109 13.5 5.25 13.5H8.43C8.5287 13.5005 8.62655 13.4816 8.71793 13.4443C8.80931 13.407 8.89242 13.352 8.9625 13.2825L14.1525 8.08495L16.2825 5.99995C16.3528 5.93023 16.4086 5.84728 16.4467 5.75589C16.4847 5.66449 16.5043 5.56646 16.5043 5.46745C16.5043 5.36845 16.4847 5.27042 16.4467 5.17902C16.4086 5.08763 16.3528 5.00468 16.2825 4.93495L13.1025 1.71745C13.0328 1.64716 12.9498 1.59136 12.8584 1.55329C12.767 1.51521 12.669 1.49561 12.57 1.49561C12.471 1.49561 12.373 1.51521 12.2816 1.55329C12.1902 1.59136 12.1072 1.64716 12.0375 1.71745L9.9225 3.83995L4.7175 9.03745C4.64799 9.10753 4.593 9.19065 4.55567 9.28202C4.51835 9.3734 4.49943 9.47125 4.5 9.56995V9.56995ZM12.57 3.30745L14.6925 5.42995L13.6275 6.49495L11.505 4.37245L12.57 3.30745ZM6 9.87745L10.4475 5.42995L12.57 7.55245L8.1225 12H6V9.87745Z"
            fill="#03267A"
          />
        </svg>
        {{ $t("multidisciplinary_board.lbl_modify_short") }}
      </button>
      <div
        class="text-black mx-2 fs-14 fw-500 h-4 cursor-pointer mb-3"
        @click="backList"
        v-if="!loading"
      >
        <svg
          width="40"
          height="46"
          viewBox="0 0 48 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.6276 24.7096L33.6976 17.6376C33.8887 17.4531 34.041 17.2324 34.1458 16.9884C34.2507 16.7444 34.3058 16.4819 34.3081 16.2164C34.3104 15.9508 34.2598 15.6874 34.1593 15.4416C34.0587 15.1959 33.9102 14.9725 33.7224 14.7848C33.5346 14.597 33.3113 14.4485 33.0655 14.3479C32.8198 14.2473 32.5564 14.1967 32.2908 14.1991C32.0253 14.2014 31.7628 14.2565 31.5188 14.3613C31.2748 14.4662 31.0541 14.6185 30.8696 14.8096L23.7976 21.8796L16.7276 14.8096C16.5431 14.6185 16.3225 14.4662 16.0784 14.3613C15.8344 14.2565 15.572 14.2014 15.3064 14.1991C15.0409 14.1967 14.7775 14.2473 14.5317 14.3479C14.2859 14.4485 14.0626 14.597 13.8748 14.7848C13.6871 14.9725 13.5386 15.1959 13.438 15.4416C13.3374 15.6874 13.2868 15.9508 13.2891 16.2164C13.2914 16.4819 13.3466 16.7444 13.4514 16.9884C13.5563 17.2324 13.7086 17.4531 13.8996 17.6376L20.9696 24.7076L13.8996 31.7796C13.7086 31.964 13.5563 32.1847 13.4514 32.4287C13.3466 32.6728 13.2914 32.9352 13.2891 33.2007C13.2868 33.4663 13.3374 33.7297 13.438 33.9755C13.5386 34.2213 13.6871 34.4446 13.8748 34.6323C14.0626 34.8201 14.2859 34.9686 14.5317 35.0692C14.7775 35.1698 15.0409 35.2204 15.3064 35.2181C15.572 35.2157 15.8344 35.1606 16.0784 35.0558C16.3225 34.9509 16.5431 34.7986 16.7276 34.6076L23.7976 27.5376L30.8696 34.6076C31.0541 34.7986 31.2748 34.9509 31.5188 35.0558C31.7628 35.1606 32.0253 35.2157 32.2908 35.2181C32.5564 35.2204 32.8198 35.1698 33.0655 35.0692C33.3113 34.9686 33.5346 34.8201 33.7224 34.6323C33.9102 34.4446 34.0587 34.2213 34.1593 33.9755C34.2598 33.7297 34.3104 33.4663 34.3081 33.2007C34.3058 32.9352 34.2507 32.6728 34.1458 32.4287C34.041 32.1847 33.8887 31.964 33.6976 31.7796L26.6276 24.7076V24.7096Z"
            fill="black"
          />
        </svg>
      </div>
    </div>

    <div ref="viewDetail">
      <div id="PhieuGayMeViewDetail" class="mx-auto hodo-print">
        <div class="row mb-3">
          <div class="col-3 flex">
            <div class="fs-17 uppercase">
              <div>
                <div>
                  <p class="mb-0">
                    {{
                      $globalClinic && $globalClinic.organization
                        ? $globalClinic.organization.authority_in_charge
                        : ""
                    }}
                  </p>
                </div>
                <div>
                  <p class="mb-0">
                    {{
                      $globalClinic && $globalClinic.organization
                        ? $globalClinic.organization.name
                        : ""
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 uppercase">
            <p class="text-xl text-center font-bold fs-24">
              PHIẾU KHÁM GÂY MÊ TRƯỚC MỔ
            </p>
          </div>
          <div class="col-3"></div>
        </div>

        <div class="border-t border-r border-l">
          <div class="flex">
            <div class="col-4 border-r">
              <div class="pl-2 pt-1">
                <div class="flex">
                  <p class="fs-17 whitespace-nowrap">Họ tên:&nbsp;</p>
                  <p class="fs-17 mb-0 uppercase font-bold">
                    {{ person.name }}
                  </p>
                </div>
                <div class="flex justify-between mt-3">
                  <div class="flex">
                    <p class="fs-17">Tuổi:</p>
                    <p class="ml-1 mb-0 fs-17">{{ person.age }}</p>
                  </div>
                  <div class="flex mr-1">
                    <p class="ml-3 fs-17">Giới tính:</p>
                    <p class="mb-0 fs-17 ml-1">{{ getGender() }}</p>
                  </div>
                </div>
                <div class="flex mt-3">
                  <p class="fs-17">Nhóm máu:</p>
                  <p class="ml-1 mb-0 fs-17">{{ form.blood }}</p>
                </div>
              </div>
            </div>
            <div class="col-6 border-r">
              <div class="p-1">
                <div class="flex">
                  <div class="col-6">
                    <div class="flex items-center">
                      <p class="fs-17">Nặng:</p>
                      <p class="ml-1 mb-0 fs-17">{{ form.weight }} kg</p>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="flex items-center">
                      <p class="fs-17">Chiều cao:</p>
                      <p class="mb-0 ml-1 fs-17">{{ form.height }} cm</p>
                    </div>
                  </div>
                </div>
                <div class="flex mt-3">
                  <div class="col-6">
                    <div class="flex items-center">
                      <p class="fs-17">ASA:</p>
                      <p class="ml-1 mb-0 fs-17">{{ form.asa }}</p>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="flex items-center">
                      <p class="fs-17">Mallampati:</p>
                      <p class="mb-0 ml-1 fs-17">{{ form.mallampati }}</p>
                    </div>
                  </div>
                </div>
                <div class="flex mt-3">
                  <div class="col-6">
                    <div class="flex items-center">
                      <p class="fs-17">K/c cằm giáp:</p>
                      <p class="ml-1 mb-0 fs-17">{{ form.chin }} cm</p>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="flex items-center">
                      <p class="fs-17">Há miệng:</p>
                      <p class="ml-1 fs-17">{{ form.mounted }} cm</p>
                    </div>
                  </div>
                </div>
                <div class="flex items-center mt-3 whitespace-nowrap">
                  <div class>
                    <p class="fs-17">Răng giả:</p>
                  </div>
                  <div class="flex-1 p-1 flex items-center mx-1">
                    <div
                      class="h-3 w-3 box-nv mx-0 mr-1 flex justify-center items-center"
                    >
                      <span
                        v-if="form.dentures === 1"
                        class="fs-11 m-0 p-0 font-bold"
                        >X</span
                      >
                    </div>
                    <p class="fs-17">Không</p>
                  </div>
                  <div class="flex-1 flex items-center mx-1">
                    <div
                      class="h-3 w-3 box-nv mx-0 mr-1 flex justify-center items-center"
                    >
                      <span
                        v-if="form.dentures === 2"
                        class="fs-11 m-0 p-0 font-bold"
                        >X</span
                      >
                    </div>
                    <p class="fs-17">Tháo được</p>
                  </div>
                  <div class="flex-1 p-1 flex items-center mx-1">
                    <div
                      class="h-3 w-3 box-nv mx-0 mr-1 flex justify-center items-center"
                    >
                      <span
                        v-if="form.dentures === 3"
                        class="fs-11 m-0 p-0 font-bold"
                        >X</span
                      >
                    </div>
                    <p class="fs-17">Cố định</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-2">
              <div class="p-1 pl-2">
                <div>
                  <p class="mb-0 fs-17">
                    Bữa ăn cuối trước mổ:
                    {{ form.last_meal_at ? form.last_meal_at : "" }}
                    <span>giờ</span>
                  </p>
                </div>
                <div class="flex items-center mt-3 p-0">
                  <div
                    class="h-3 w-3 box-nv p-0 mx-0 mr-1 flex flex-col justify-center items-center"
                  >
                    <span
                      v-if="form.is_emergency === 1"
                      class="fs-11 mb-0.5 p-0 font-bold"
                      >X</span
                    >
                  </div>
                  <p class="fs-17">Cấp cứu</p>
                </div>
                <div class="flex items-center mt-3">
                  <div
                    class="h-3 w-3 box-nv mx-0 mr-1 flex justify-center items-center"
                  >
                    <span
                      v-if="form.is_stomach === 1"
                      class="fs-11 mb-0.5 p-0 font-bold"
                      >X</span
                    >
                  </div>
                  <p class="fs-17">Dạ dày đầy</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="border-t border-r border-l p-2">
          <div class="mb-1 mt-1 overflow-hidden">
            <div class="whitespace-nowrap float-left mr-1 fs-17">
              Chẩn đoán:
            </div>
            <div class="mb-0 content-size fs-17" v-html="form.diagnose"></div>
          </div>
          <div class="mb-1 overflow-hidden">
            <div class="whitespace-nowrap float-left mr-1 fs-17">
              Hướng xử trí:
            </div>
            <div class="mb-0 content-size fs-17" v-html="form.treatment"></div>
          </div>
        </div>
        <div class="border-t border-r border-l p-2">
          <div class="mb-1 overflow-hidden">
            <div class="whitespace-nowrap float-left mr-1 fs-17">
              Tiền sử nội khoa:
            </div>
            <div
              class="mb-0 content-size fs-17"
              v-html="form.medical_his"
            ></div>
          </div>
          <div class="mb-1 overflow-hidden">
            <div class="whitespace-nowrap float-left mr-1 fs-17">
              Tiền sử ngoại khoa:
            </div>
            <div
              class="mb-0 content-size fs-17"
              v-html="form.surgery_his"
            ></div>
          </div>
          <div class="row mb-1">
            <div class="col-7 overflow-hidden">
              <div class="whitespace-nowrap float-left mr-1 fs-17">
                Tiền sử gây mê, gây tê:
              </div>
              <div
                class="mb-0 content-size fs-17"
                v-html="form.anesthesia_his"
              ></div>
            </div>
            <div class="col-5 overflow-hidden">
              <div class="whitespace-nowrap float-left mr-1 fs-17">Dị ứng:</div>
              <div class="mb-0 content-size fs-17" v-html="form.allergy"></div>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-7">
              <div class="flex">
                <p class="fs-17">Nghiện chất:</p>
                <div class="flex items-center mx-1">
                  <div
                    class="h-3 w-3 box-nv mt-0 mr-1 flex justify-center items-center"
                  >
                    <span v-if="form.is_tobacco" class="fs-11 m-0 p-0 font-bold"
                      >X</span
                    >
                  </div>
                  <p class="fs-17">Thuốc lá, thuốc lào</p>
                </div>
                <div class="flex items-center mx-1">
                  <div
                    class="h-3 w-3 box-nv mt-0 mr-1 flex justify-center items-center"
                  >
                    <span v-if="form.is_alcoho" class="fs-11 m-0 p-0 font-bold"
                      >X</span
                    >
                  </div>
                  <p class="fs-17">Rượu</p>
                </div>
                <div class="flex items-center mx-1">
                  <div
                    class="h-3 w-3 box-nv mt-0 mr-1 flex justify-center items-center"
                  >
                    <span v-if="form.is_drug" class="fs-11 m-0 p-0 font-bold"
                      >X</span
                    >
                  </div>
                  <p class="fs-17">Ma túy</p>
                </div>
              </div>
            </div>
            <div class="col-5 overflow-hidden">
              <div class="whitespace-nowrap float-left mr-1 fs-17">
                Bệnh lây nhiễm:
              </div>
              <div
                class="mb-0 content-size fs-17"
                v-html="form.infection"
              ></div>
            </div>
          </div>
          <div class="overflow-hidden">
            <div class="whitespace-nowrap float-left mr-1 fs-17">
              Thuốc đang điều trị:
            </div>
            <div
              class="mb-0 content-size fs-17"
              v-html="form.treat_medication || ''"
            ></div>
          </div>
        </div>

        <div class="border-t border-r border-l p-2">
          <div class="mb-1 overflow-hidden">
            <div class="whitespace-nowrap float-left mr-1 fs-17">
              Khám lâm sàng:
            </div>
            <div
              class="mb-0 content-size fs-17"
              v-html="form.clinical_examination || ''"
            ></div>
          </div>
          <div class="row mb-1">
            <div class="col-6 overflow-hidden">
              <div class="whitespace-nowrap fs-17 float-left mr-1">
                Tuần hoàn:
              </div>
              <div
                class="mb-0 content-size fs-17"
                v-html="form.cyclic || ''"
              ></div>
            </div>
            <div class="col-3">
              <p class="mb-0">
                <label class="mb-0 mr-1 fs-17">M:</label>
                <span class="fs-17">{{ form.pulse }}</span>
              </p>
            </div>
            <div class="col-3">
              <p class="mb-0">
                <label class="mb-0 mr-1 fs-17">HA:</label>
                <span class="fs-17">{{ form.blood_pressure_high }}</span>
                <span class="mx-1">/</span>
                <span class="fs-17">{{ form.blood_pressure }}</span>
              </p>
            </div>
          </div>
          <div class="mb-1 overflow-hidden">
            <div class="whitespace-nowrap float-left mr-1 fs-17">Hô hấp:</div>
            <div
              class="mb-0 content-size fs-17"
              v-html="form.respiratory"
            ></div>
          </div>
          <div class="row mb-1">
            <div class="col-6 overflow-hidden">
              <div class="whitespace-nowrap float-left mr-1 fs-17">
                Thần kinh:
              </div>
              <div class="mb-0 content-size fs-17" v-html="form.nerve"></div>
            </div>
            <div class="col-6 overflow-hidden">
              <div class="whitespace-nowrap float-left mr-1 fs-17">
                Cột sống:
              </div>
              <div class="mb-0 content-size fs-17" v-html="form.spine"></div>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 overflow-hidden">
              <div class="whitespace-nowrap float-left mr-1 fs-17">
                Xét nghiệm bất thường:
              </div>
              <div
                class="mb-0 content-size fs-17"
                v-html="form.abnormal_examination"
              ></div>
            </div>
            <div class="col-6 overflow-hidden">
              <div class="whitespace-nowrap float-left mr-1 fs-17">
                Yêu cầu bổ sung:
              </div>
              <div
                class="mb-0 content-size fs-17"
                v-html="form.additional_request"
              ></div>
            </div>
          </div>
          <div class="row">
            <div class="col-6 overflow-hidden">
              <div class="whitespace-nowrap float-left mr-1 fs-17">
                Dự kiến cách và thuốc vô cảm:
              </div>
              <div
                class="mb-0 content-size fs-17"
                v-html="form.anaesthetic_method"
              ></div>
            </div>
            <div class="col-6 overflow-hidden">
              <div class="whitespace-nowrap float-left mr-1 fs-17">
                Dự kiến giảm đau sau mổ:
              </div>
              <div
                class="mb-0 content-size fs-17"
                v-html="form.pain_relief"
              ></div>
            </div>
          </div>
        </div>
        <div class="border-t border-r border-l p-2">
          <div class="mb-1 row">
            <div class="col-6 overflow-hidden">
              <div class="whitespace-nowrap float-left mr-1 fs-17">
                Y lệnh trước mổ và thuốc tiền mê:
              </div>
              <div
                class="mb-0 content-size fs-17"
                v-html="form.medical_order"
              ></div>
            </div>
            <div class="col-6 text-center">
              <p class="fs-17 pb-20">Họ tên, chữ ký của Điều dưỡng thực hiện</p>
              <p class="font-bold mt-5 text-center fs-17">
                {{ (form.nurse && form.nurse.name) || form.nurse_name }}
              </p>
            </div>
          </div>
        </div>
        <div class="border-box">
          <div class="flex">
            <div class="col-6 flex border-r">
              <div class="p-2 text-center">
                <div class>
                  <p class="mb-0">
                    <label class="mb-0 mr-1 fs-17">Ngày khám:</label>
                    <span class="fs-17">
                      {{
                        form.examination_date
                          ? formatDateTime(form.examination_date)
                          : ""
                      }}
                    </span>
                  </p>
                </div>
                <div>
                  <p class="fs-17 pb-20">Họ tên, chữ ký của Bác sĩ gây mê</p>
                  <p class="font-bold mt-5 fs-17">
                    {{
                      (form.anesthesia_doctor && form.anesthesia_doctor.name) ||
                      form.anesthesia_doctor_name ||
                      ""
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-6 flex">
              <div class="p-2 text-center">
                <div class>
                  <p class="mb-0">
                    <label class="mb-0 mr-1 fs-17">Ngày khám:</label>
                    <span class="fs-17">
                      {{
                        form.visit_before_date
                          ? formatDateTime(form.visit_before_date)
                          : ""
                      }}
                    </span>
                  </p>
                </div>
                <div class>
                  <p class="fs-17 pb-20">Họ tên, chữ ký của Bác sĩ gây mê</p>
                  <p class="font-bold mt-5 fs-17">
                    {{
                      (form.anesthesia_visit_doctor &&
                        form.anesthesia_visit_doctor.name) ||
                      form.anesthesia_doctor_visit_name ||
                      ""
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modalUpdateForm :type="'update'" @onUpdate="putAnesthesia($event)" />
    <ModalSignPDF
      ref="GayMeModalSignPDF"
      containerIDProps="GayMeContainerSignPDFID"
      elementIDProps="GayMeSignPDFID"
      imageIDProps="GayMeSignPDFImageID"
      :envelopeName="envelopeName"
      @onSuccess="handleSignDocumentSuccess"
      @onClose="onRefresh"
    />
    <PdfViewer
      ref="GayMePdfViewer"
      containerIDProps="ContainerGayMePDFViewerID"
      elementIDProps="GayMePDFViewerID"
      @onClose="onRefresh"
    />
  </div>
</template>

<script>
import modalUpdateForm from './ModalPhieuGayMe'
import { mapState } from 'vuex'
import appUtils from '../../../utils/appUtils'
import {
  ENVELOPE_DOCUMENT_TYPE,
  ENVELOPE_NAME_TYPE
  // SIGN_ENVELOPE_STATUS
} from '../../../utils/constants'
import SignatureRequest from '../../../api/request/SignatureRequest'
import ModalSignPDF from '../../Signature/ModalSignPDF.vue'
import uploadS3File from '../../../utils/uploadS3File'
import PdfViewer from '../../PdfViewer/PdfViewer.vue'
import { mixinSignPdf } from '../../../utils/mixinSignPdf'

export default {
  name: 'GayMeTruocMoDetail',
  mixins: [mixinSignPdf],
  components: { modalUpdateForm, ModalSignPDF, PdfViewer },
  data () {
    return {
      form: {
        date: null,
        nurse_id: null,
        nurse: {},
        anesthesia_doctor_visit_id: null,
        anesthesia_visit_doctor: {},
        examination_date: null,
        visit_before_date: null,
        anesthesia_doctor_id: '',
        anesthesia_doctor: {},
        last_meal_at: '',
        pulse: '',
        weight: '',
        height: '',
        blood: '',
        chin: '',
        mounted: '',
        asa: 1,
        pain_relief: '',
        mallampati: 1,
        is_stomach: 0,
        is_emergency: null,
        dentures: 0,
        treatment: '',
        medical_his: '',
        surgery_his: '',
        anesthesia_his: '',
        allergy: '',
        is_tobacco: 0,
        is_alcoho: 0,
        is_drug: 0,
        is_infectious: 0,
        treat_medication: '',
        clinical_examination: '',
        cyclic: '',
        blood_pressure_high: '',
        blood_pressure: '',
        respiratory: '',
        nerve: '',
        spine: '',
        abnormal_examination: '',
        additional_request: '',
        anaesthetic_method: '',
        medical_order: '',
        pre_anesthetic: '',
        diagnose: ''
      },
      options1: [
        {
          value: '2',
          label: '2'
        },
        {
          value: '3',
          label: '3'
        },
        {
          value: '4',
          label: '4'
        },
        {
          value: '5',
          label: '5'
        }
      ],
      options2: [
        {
          value: '2',
          label: '2'
        },
        {
          value: '3',
          label: '3'
        },
        {
          value: '4',
          label: '4'
        }
      ],
      doctors: null,
      loading: false,
      type: null
    }
  },
  mounted () {
    this.getDoctors()
    this.getShowAnesthesia()
    this.type = this.$route.query.type
  },
  watch: {
    '$route.query.type' (val) {
      this.type = val
    }
  },
  computed: {
    ...mapState({
      person: (state) => state.person
    }),
    ...mapState({
      medicalRecordMain: (state) => state.medicalRecordMain,
      emrData: (state) => state.emrData
    }),
    envelopeName () {
      return this.handleGetEnvelopeName(ENVELOPE_NAME_TYPE.emr, this.emrData)
    }
  },
  methods: {
    formatDate (date) {
      return window.moment(date).format('HH:mm DD/MM/YYYY')
    },
    formatDateTime (date) {
      return window.moment(date).format('DD/MM/YYYY')
    },
    getGender () {
      return appUtils.getGender(this.person.gender)
    },
    async getDoctors () {
      const clinic_id = this.$clinicId
      const res = await this.$rf
        .getRequest('DoctorRequest')
        .getDoctorsOfWorkspace(clinic_id, { limit: 1000 })
      this.doctors = res.data?.data
    },
    async getShowAnesthesia () {
      let id = this.$route.query.vId
      if (!id) {
        return
      }
      this.loading = true
      await this.$rf
        .getRequest('DoctorRequest')
        .getShowAnesthesia(id)
        .then((r) => {
          this.form = r.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    async postAnesthesia () {
      const params = {
        medical_record_id: this.$route.params.id,
        ...this.form
      }
      await this.$rf
        .getRequest('DoctorRequest')
        .postAnesthesia(params)
        .then((r) => {
          this.$toast.open({
            message: 'Tải lên thành công',
            type: 'success'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async putAnesthesia (event) {
      const id = this.$route.query.vId
      this.loading = true
      const params = {
        ...event,
        medical_record_id: this.$route.params.id,
        blood_pressure: event?.blood_pressure?.toString() || ''
      }
      await this.$rf
        .getRequest('DoctorRequest')
        .putAnesthesia(id, params)
        .then((r) => {
          this.getShowAnesthesia()
          this.$toast.open({
            message: 'Chỉnh sửa thành công',
            type: 'success'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    ModalUpdate (show) {
      window.$('#modalPhieuGMTM').modal(show ? 'show' : 'hide')
    },
    onRefresh () {
      this.loading = false
      this.getShowAnesthesia()
    },
    backList () {
      this.$router.replace({ query: { tab: this.$route.query.tab } })
    },
    async onPrintNe (isOpen) {
      const self = this
      const bodyHTML = self.$refs.viewDetail.innerHTML
      const tempHTML = appUtils.templateHTMLPrint({ bodyHTML })
      const base64Data = appUtils.base64.decode(tempHTML)
      const url = await this.savePdfToS3(base64Data, isOpen)
      return url
    },
    async savePdfToS3 (base64, isOpen = true) {
      try {
        this.loading = true

        const payload = {
          content: base64,
          fileName: 'PhieuGayMeTruocMo',
          path: 'consultations',
          type: 'test',
          type_id: 'test',
          uuid: 'test'
        }

        const res = await this.$rf
          .getRequest('DoctorRequest')
          .printDocument(payload)

        if (res?.data && isOpen) {
          this.loading = false
          window.open(res.data?.documentLink, '_blank', 'noreferrer')
        }
        return res.data?.documentLink
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async openModalSignPdf (item) {
      let error
      let signer
      if (
        this.form?.anesthesia_doctor_id !== this.$user?.id &&
        this.form?.anesthesia_doctor_visit_id !== this.$user?.id &&
        this.form?.nurse_id !== this.$user?.id
      ) {
        this.$toast.open({
          message: 'Bạn không có quyền ký tài liệu này',
          type: 'error'
        })
        return
      }

      const documentLink = await this.onPrintNe(false)

      if (!documentLink) {
        this.$toast.open({
          message: 'Không tìm thấy tài liệu cần ký',
          type: 'error'
        })
        return
      }
      const envelopeInfo = await this.handleCheckSignEnvelope()
      if (envelopeInfo) return

      const procedure = await this.handleProcessProcedureData(
        (err, signerData) => {
          if (err) {
            error = true
            this.$toast.open({
              message: err,
              type: 'error'
            })
          } else signer = signerData
        }
      )
      if (error) return
      this.$nextTick(() => {
        this.$refs.GayMeModalSignPDF.handleOpen(
          documentLink,
          ENVELOPE_DOCUMENT_TYPE.PRE_OPERATIVE_ANESTHESIA_FORM,
          Number(item),
          signer?.id,
          procedure?.signatories || [],
          null,
          procedure?.id
        )
      })
    },
    async getSignProcedures () {
      try {
        const params = {
          page_num: 1,
          page_size: 1000,
          order: 'desc',
          sort_by: 'id',
          document_type: ENVELOPE_DOCUMENT_TYPE.PRE_OPERATIVE_ANESTHESIA_FORM,
          ws_id: this.$globalClinic?.id
        }

        const request = new SignatureRequest()

        const response = await request.getSignProcedures(params)

        return response.data?.data?.[0]
      } catch (error) {
        console.log(error)
      }
    },
    async handleProcessProcedureData (callback) {
      const procedure = await this.getSignProcedures()

      const signatories = procedure?.sign_nodes?.reduce((arr, node) => {
        const signs = node?.node_signatories?.map((item) => {
          const user = this.getUserByRoles(item?.user_role, callback)
          return {
            ...item,
            user,
            user_id: user?.id
          }
        })
        return arr.concat(signs)
      }, [])
      return { ...procedure, signatories }
    },
    getUserByRoles (role, callback) {
      let user
      let signer
      switch (role) {
        case 'nurse':
          const nurse_id = this.form?.nurse?.id
          if (!nurse_id) {
            // eslint-disable-next-line standard/no-callback-literal
            callback('Không tìm thấy thông tin Y tá')
            this.loading = false
          } else {
            user = this.form?.nurse || {}
            if (user?.id === this.$user?.id && user?.id) {
              signer = user
              callback(null, signer)
            }
          }

          break
        case 'anesthesiologist_doctor_1':
          const anesthesia_doctor_id = this.form?.anesthesia_doctor?.id
          if (!anesthesia_doctor_id) {
            // eslint-disable-next-line standard/no-callback-literal
            callback('Không tìm thấy thông tin Bác sĩ gây mê')
            this.loading = false
          } else {
            user = this.form?.anesthesia_doctor || {}
            if (user?.id === this.$user?.id && user?.id) {
              signer = user
              callback(null, signer)
            }
          }

          break
        case 'anesthesiologist_doctor_2':
          const anesthesia_visit_doctor_id =
            this.form?.anesthesia_visit_doctor?.id
          if (!anesthesia_visit_doctor_id) {
            // eslint-disable-next-line standard/no-callback-literal
            callback('Không tìm thấy thông tin Bác sĩ gây mê')
            this.loading = false
          } else {
            user = this.form?.anesthesia_visit_doctor || {}
            if (user?.id === this.$user?.id && user?.id) {
              signer = user
              callback(null, signer)
            }
          }

          break

        default:
          break
      }

      return user
    },
    async handleSignDocumentSuccess () {
      this.$router.replace({ query: { tab: this.$route.query.tab } })
    },
    async handleCheckSignEnvelope () {
      try {
        const documentID = Number(this.$route.query.vId)
        const signEnvelope = await this.getSignEnvelopeByDocID()
        if (!signEnvelope) return

        const signatories = signEnvelope?.envelope_signatories?.map((item) => ({
          ...item,
          user: item?.user_info,
          user_id: item?.user_id
        }))

        const signerInfo = signEnvelope?.envelope_signatories?.find(
          (item) => item?.user_id === this.$user?.id
        )

        const s3Url = await uploadS3File.getLinkVideoAWS(
          signEnvelope?.document_url
        )

        if (signerInfo?.status === 2) {
          this.$nextTick(() => {
            this.$refs.GayMePdfViewer.handleOpen(
              s3Url,
              ENVELOPE_DOCUMENT_TYPE.PRE_OPERATIVE_ANESTHESIA_FORM,
              documentID,
              false,
              false
            )
          })
        } else {
          this.$nextTick(() => {
            this.$refs.GayMeModalSignPDF.handleOpen(
              s3Url,
              ENVELOPE_DOCUMENT_TYPE.PRE_OPERATIVE_ANESTHESIA_FORM,
              documentID,
              signerInfo?.user_id,
              signatories || [],
              signEnvelope
            )
          })
        }

        return signEnvelope
      } catch (error) {
        console.log(error)
      }
    },
    async getSignEnvelopeByDocID () {
      try {
        const request = new SignatureRequest()
        const response = await request.getSignEnvelopeByDocumentID({
          doc_id: Number(this.$route.query.vId),
          doc_type: ENVELOPE_DOCUMENT_TYPE.PRE_OPERATIVE_ANESTHESIA_FORM
        })

        return response.data
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-table--border,
  .el-table--group {
    border: 1px solid #000;
  }
  .el-table--border th.el-table__cell,
  .el-table__fixed-right-patch {
    border-bottom: 1px solid #000 !important;
  }
  .el-table--border .el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    border-right: 1px solid #000 !important;
  }
  div {
    word-break: inherit !important;
  }
  div.cell {
    padding: 0 4px !important;
  }
}
.content-none {
  width: 100%;
  border-bottom: 2px dotted;
}
.borderBox {
  border: 1px solid black;
  border-bottom: none;
}
.border-right {
  border-right: 1px black;
  // border-right: none;
}
.border-b {
  border-bottom: 1px solid;
}
.border-box {
  border: 1px solid black;
}

.col-border {
  border-right: 1px solid #030303;
}
</style>
